import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import './OpeningHours.scss'

class OpeningHours extends PureComponent {
  render () {
    const iconContainerClass = this.props.showIcon ? 'opening-hours-icon' : ''
    const openingHours = this.props.hours.slice(0)
    const currentDay = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    const getDay = new Date().getDay()

    if (openingHours.length > 0) {
      if (openingHours[0].date === 'Sunday') { // Sunday being 0 fix
        openingHours.push(openingHours.shift())
      }
    }

    return (
      <div className={`opening-hours ${iconContainerClass}`}>

        <h2 className='oh-title' tabIndex={this.props.tabbable ? 0 : -1}>
          Our opening hours...
          {
            this.props.showIcon &&
            <span className='argos-icon icon-UIE-TimeSlot' aria-hidden='true' />
          }
        </h2>

        <ul className='oh-lists'>
          {
            openingHours.map((opening, index) => {
              const dateActiveClass = currentDay[getDay] === opening.date ? 'oh-date-block oh-active' : 'oh-date-block'
              return (
                <li key={index} className='oh-list' tabIndex={this.props.tabbable ? 0 : -1}>
                  <span className={dateActiveClass}>
                    <span className='oh-date-short' aria-hidden='true' >{opening.date.substring(0, 3)}</span>
                    <span className='oh-date'>{opening.date}</span>
                    <span className='oh-time'>{opening.time}</span>
                  </span>
                  <span hidden className='data-test' itemProp='openingHours' dateTime={opening.date.substring(0, 3) + ' ' + opening.time}>
                    {opening.date.substring(0, 3) + ' ' + opening.time}
                  </span>
                </li>
              )
            })
          }
        </ul>
      </div>
    )
  }
}

OpeningHours.defaultProps = {
  showIcon: false,
  tabbable: false
}

OpeningHours.propTypes = {
  showIcon: PropTypes.bool,
  tabbable: PropTypes.bool,
  hours: PropTypes.array
}

export default OpeningHours



// WEBPACK FOOTER //
// ./src/components/OpeningHours/OpeningHours.jsx